module.exports = __webpack_public_path__ + "static/img/logo.86846e1c.png";